module.exports = __webpack_public_path__ + "img/28m.61be1be0.png";